module.exports = __webpack_public_path__ + "f47f5504f38b160574d60a1964a7310c.pdf";